import { api } from "../configs/axiosConfigs";

export const EMERGENCY_ACCESS_COOKIE = "SolarentEmergencyAccess";
export const EMERGENCY_ACCESS_STORAGE_KEY = "solarent_emergency_access_until";

const readCookie = (name) => {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

export const syncEmergencyAccessFromApi = (status) => {
  const active = status?.active ?? status?.Active;
  if (!active) {
    sessionStorage.removeItem(EMERGENCY_ACCESS_STORAGE_KEY);
    return false;
  }
  const untilMs = status.activeUntilUtc || status.ActiveUntilUtc
    ? new Date(status.activeUntilUtc || status.ActiveUntilUtc).getTime()
    : Date.now() + (status.minutesRemaining ?? status.MinutesRemaining ?? 15) * 60 * 1000;
  if (untilMs > Date.now()) {
    sessionStorage.setItem(EMERGENCY_ACCESS_STORAGE_KEY, String(untilMs));
    return true;
  }
  return false;
};

export const isEmergencyAccessActive = () => {
  if (readCookie(EMERGENCY_ACCESS_COOKIE) === "1") return true;
  const until = Number(sessionStorage.getItem(EMERGENCY_ACCESS_STORAGE_KEY) || 0);
  return until > Date.now();
};

export const fetchAndSyncEmergencyAccess = async () => {
  try {
    const res = await api.get("api/dev/emergency-access/status");
    const payload = res?.data?.data ?? res?.data?.Data ?? res?.data;
    return syncEmergencyAccessFromApi(payload);
  } catch {
    return isEmergencyAccessActive();
  }
};

export const isUmRecoveryPath = (pathname) => {
  const p = String(pathname || "").toLowerCase();
  return p === "/um" || p.startsWith("/um/");
};
